import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { routeHooks } from 'router';


/**
 * Hook מותאם אישית לבדיקה האם המשתמש נמצא כרגע במסך מבדקי לימוד (Training Mode).
 * ה-Hook לוקח את ה-URL הנוכחי, מחפש את הראוט המתאים במערך הראוטים השטוח,
 * ובודק את מאפיין ה-isTrainingMode שהוגדר עבורו.
 * * @example
 * const isTraining = useIsTraining();
 * console.log(isTraining); // true or false
 * * @returns {boolean} מחזיר true אם הראוט הנוכחי מוגדר כ-isTrainingMode, אחרת מחזיר false.
 */
const useIsTraining = () => {
    const location = useLocation();
    const allRoutes = routeHooks.useFlattenedRoutes();

    // עטיפה ב-useMemo מבטיחה שפעולת החיפוש הכבדה תתבצע רק כאשר
    // הכתובת בדפדפן (pathname) או עץ הראוטים (allRoutes) משתנים.
    const isTraining = useMemo(() => {
        const currentRoute = allRoutes.find(r =>
            matchPath({ path: r.path, end: true }, location.pathname)
        );

        return currentRoute?.isTrainingMode || false;
    }, [location.pathname, allRoutes]);

    return isTraining;
};

export default useIsTraining;